/** Strings owned by the workspace area. */
export const WORKSPACE_STRINGS = {
    // ── My Devices board ────────────────────────────────────────────────────────
    'workspace.title': { en: 'My Devices', ru: 'Мои устройства' },
    'workspace.config': { en: 'Config', ru: 'Настройка' },
    'workspace.empty': {
        en: 'No devices in your workspace yet. Use {config} above to pick the phones you are working on.',
        ru: 'В рабочем пространстве пока нет устройств. Нажмите {config} выше и выберите телефоны, с которыми вы работаете.',
    },
    'workspace.not_reported_card': { en: 'Not reported by its farm', ru: 'Ферма не сообщает об устройстве' },
    'workspace.not_reported_hint': {
        en: 'Removed, or its farm agent is offline.',
        ru: 'Удалено, либо агент фермы не в сети.',
    },
    // ── My Devices · Config ─────────────────────────────────────────────────────
    'workspace.config_title': { en: 'My Devices · Config', ru: 'Мои устройства · Настройка' },
    'workspace.config_intro': {
        en: 'Tick the devices you are working on. Nothing moves between farms — a ticked device simply also appears on your board, and everyone else reaches it exactly as before.',
        ru: 'Отметьте устройства, с которыми вы работаете. Ничего не переносится между фермами — отмеченное устройство просто появляется и на вашей доске, а остальные получают к нему доступ как раньше.',
    },
    'workspace.slots_used': { en: '{used} of {limit} slots used.', ru: 'Занято слотов: {used} из {limit}.' },
    'workspace.clear_all': { en: 'Clear all', ru: 'Очистить всё' },
    'workspace.clear_confirm_one': {
        en: 'Remove all 1 device from My Devices? Running clickers keep running.',
        ru: 'Убрать 1 устройство из «Моих устройств»? Запущенные кликеры продолжат работу.',
    },
    'workspace.clear_confirm_many': {
        en: 'Remove all {count} devices from My Devices? Running clickers keep running.',
        ru: 'Убрать все устройства из «Моих устройств» ({count})? Запущенные кликеры продолжат работу.',
    },
    'workspace.loading_farms': { en: 'Loading farms…', ru: 'Загрузка ферм…' },
    'workspace.loading_devices': { en: 'Loading devices…', ru: 'Загрузка устройств…' },
    'workspace.farm_no_devices': {
        en: 'This farm reports no devices right now.',
        ru: 'Ферма сейчас не сообщает ни об одном устройстве.',
    },
    'workspace.no_farms': { en: 'No farms available to you.', ru: 'Нет доступных ферм.' },
    'workspace.state_not_reported': { en: 'not reported', ru: 'не сообщается' },
    'workspace.state_offline': { en: 'offline', ru: 'не в сети' },
    'workspace.in_work': { en: 'in work: {login}', ru: 'в работе: {login}' },
    'workspace.in_work_title': { en: 'In work: {logins}', ru: 'В работе: {logins}' },
    'workspace.in_work_tally': { en: 'in work', ru: 'в работе' },
    // ── Store errors surfaced on the Config page ────────────────────────────────
    'workspace.err_add': {
        en: 'Could not add the device to My Devices',
        ru: 'Не удалось добавить устройство в «Мои устройства»',
    },
    'workspace.err_remove': {
        en: 'Could not remove the device from My Devices',
        ru: 'Не удалось убрать устройство из «Моих устройств»',
    },
    'workspace.err_clear': { en: 'Could not clear My Devices', ru: 'Не удалось очистить «Мои устройства»' },
    'workspace.err_network': { en: 'Network error', ru: 'Ошибка сети' },
};
